module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_3_preview.61b6b2ca.jpg";